import { type IntlShape } from 'react-intl';
import { PhotoHash } from '@/types/shared';

const getLocationPhotoTitle = (photo: PhotoHash, locationDetails: any, intl: IntlShape) => {
  const { name, type, city, state, country, primaryPark, cityName, stateName, countryName } = locationDetails;
  const trailName = photo.trailName?.trim();
  const isCity = type === 'location' && name === cityName;
  const isState = type === 'location' && name === stateName;
  const isCountry = type === 'location' && name === countryName;
  const trailNameVars = {
    hasTrailName: Boolean(trailName),
    trailName
  };

  if (type === 'poi') {
    if (primaryPark) {
      return intl.formatMessage(
        { defaultMessage: 'Photo of {poiName}{hasTrailName, select, true { on {trailName}} other {}} in {primaryParkName}' },
        {
          poiName: name,
          ...trailNameVars,
          primaryParkName: primaryPark.name
        }
      );
    } else if (city) {
      return intl.formatMessage(
        { defaultMessage: 'Photo of {poiName}{hasTrailName, select, true { on {trailName}} other {}} near {cityName}' },
        {
          poiName: name,
          ...trailNameVars,
          cityName: city
        }
      );
    } else if (state) {
      return intl.formatMessage(
        { defaultMessage: 'Photo of {poiName}{hasTrailName, select, true { on {trailName}} other {}} in {stateName}' },
        {
          poiName: name,
          ...trailNameVars,
          stateName: state
        }
      );
    } else if (country) {
      return intl.formatMessage(
        { defaultMessage: 'Photo of {poiName}{hasTrailName, select, true { on {trailName}} other {}} in {countryName}' },
        {
          poiName: name,
          ...trailNameVars,
          countryName: country
        }
      );
    }
  } else if (type === 'park') {
    return intl.formatMessage(
      { defaultMessage: 'Photo in {parkName}{hasTrailName, select, true { on {trailName}} other {}}' },
      {
        parkName: name,
        ...trailNameVars
      }
    );
  } else if (isCity) {
    return intl.formatMessage(
      { defaultMessage: 'Photo{hasTrailName, select, true { of {trailName}} other {}} near {cityName}' },
      {
        cityName,
        ...trailNameVars
      }
    );
  } else if (isState) {
    return intl.formatMessage(
      { defaultMessage: 'Photo{hasTrailName, select, true { of {trailName}} other {}} in {stateName}' },
      {
        stateName,
        ...trailNameVars
      }
    );
  } else if (isCountry) {
    return intl.formatMessage(
      { defaultMessage: 'Photo{hasTrailName, select, true { of {trailName}} other {}} in {countryName}' },
      {
        countryName,
        ...trailNameVars
      }
    );
  }

  const locationArray = [type === 'park' ? name : undefined, city, state, country].filter(Boolean);

  return intl.formatMessage(
    { defaultMessage: 'Trails in {list} | AllTrails.com' },
    {
      list: locationArray.length > 0 ? `${locationArray.join(', ')} ${photo.id}` : photo.id
    }
  );
};

export default getLocationPhotoTitle;
